import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const HotelLink = ({trip, flagValidatorName, searchUrl, text, dataAction, ...props}) => {
    const [flagVisibility, setFlagVisibility] = useState(false)
    const { flights, order, passengers } = trip;

    let checkin = flights.outbound.arrivalDate.split(" ")[0];
    let checkout = flights.inbound && flights.inbound.departureDate && flights.inbound.departureDate.split(" ")[0];
    const destinationIata = flights.outbound.to;

    checkin = moment(checkin, "DD-MM-YYYY").format('YYYY-MM-DD');
    checkout = moment(checkout, "DD-MM-YYYY").format('YYYY-MM-DD');

    const isAPastFlight =  moment.now() > moment(checkin);

    const adults = passengers.adults.length || 1;
    const children = passengers.children.length;
    const infant = passengers.infants.length;

    const finalUrl = `\
${searchUrl}\
${checkin ? `checkin=${checkin};` : ''}\
${checkout
    ? `checkout=${checkout};`
    : (checkin
    ? `checkout=${moment(checkin).add(1, 'days').format('YYYY-MM-DD')};`
    : '')
}\
iata_orr=1;\
iata=${destinationIata};\
group_adults=${adults};\
group_children=${children + infant};\
${'age=12;'.repeat(children)}\
${'age=1;'.repeat(infant)}\
label=MinhasViagens-Maxmilhas`;

    useEffect(() => {
        if(!window.localStorage.getItem(flagValidatorName)) {
            setFlagVisibility(true)
            window.localStorage.setItem(flagValidatorName, true)
        }
    }, [])

    if(!isAPastFlight) {
        return (<>
            <a href={finalUrl} target='_blank' data-action={dataAction}>
                {text}
                { flagVisibility && <span>Novo</span> }
            </a>
        </>)
    } else {
        return <div></div>
    }
}

HotelLink.displayName = "HotelLink";

HotelLink.defaultProps = {
    text: 'Hotel com desconto',
    searchUrl: 'https://sp.booking.com/searchresults.pt-br.html?aid=1771436;',
    flagValidatorName: 'FLAG_HAS_BEEN_SEEN',
    dataAction: '',
}

HotelLink.propTypes = {
    text: PropTypes.string,
    searchUrl: PropTypes.string,
    flagValidatorName: PropTypes.string,
    dataAction: PropTypes.string,
}

export default HotelLink;